export default __webpack_public_path__ + "static/media/NevroLoginScreen.0cc32a97.jpg";